export default (value?: unknown): boolean => Boolean(value)
